import labels from '../../utils/constants/labels';
import ApiValues from '../url/apiurl'
//action created by dulcy
var axios = require('axios');
import Networking from '../../utils/api/apiaccess';
function deleteNominee(ID, NomineeID) {


    var raw = JSON.stringify({
        "NomineeID": ID,
        "UserID": NomineeID,

    });
    // var config = {
    //     method: 'post',
    //     url: ApiValues.DeleteNominee,
    //     headers: {
    //         'Content-Type': 'application/json'
    //     },
    //     data: raw
    // };

    // return axios(config)
    //     .then(function (response) {
    //         return response.data
    //     })
    //     .catch(function (error) {
    //         return { "status": "F","message":labels.messages.apierror }
    //     });
    return Networking.PostApi(ApiValues.DeleteNominee, raw).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }
    });

}
export default deleteNominee
